import React from "react";
import "./InfoIconButton.scss";

export default function InfoIconButton({
  onClick,
  size = 44,                    // match your Select height
  ariaLabel = "Open condition help",
  title = "Open condition help",
  disabled = false,
}) {
  return (
    <span
      //type="button"
      className="btn-info"
      style={{ "--btn-size": `${size}px` }}
      onClick={onClick}
      aria-label={ariaLabel}
      title={title}
      disabled={disabled}
    >
      {/* Simple “i” in a circle that inherits currentColor */}
      <svg className="btn-info__icon" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="10" fill="none" stroke="#0071e7" strokeWidth="2" />
        <path d="M11 10h2v8h-2zM12 6a1 1 0 110 2 1 1 0 010-2z" fill="#0071e7" />
      </svg>
    </span>
  );
}
